import { cva } from '@/styled-system/css';

export const calendarYearSelectButtonRecipe = cva({
  base: {
    // override the width and height of icon-button
    'width': '700!',
    'height': '700!',
    'padding': 0,
    'border': 'none',
    'display': 'grid',
    'placeItems': 'center',
    'position': 'absolute',
    'right': 0,
    'top': '50%',
    'transform': 'translateY(-50%)',
    'backgroundColor': { base: 'bg.action.bare.neutral.default' },
    'color': {
      base: 'icon.neutral',
    },
    'pointerEvents': 'none',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'background-color, box-shadow',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',
    '& svg': {
      width: 'icon.sm',
      height: 'icon.sm',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'icon.neutral-fixed',
          _pressed: 'icon.neutral-fixed',
        },
        backgroundColor: {
          _groupHover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        _groupFocus: {
          boxShadow: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  },
});
